import { getParent, types } from 'mobx-state-tree';

import { IsoDate, IsoDateTimeWithOffset, partiallyUpdateModel } from '../definitions/Common';

import Agent from './Agent';
import Attachment from './Attachment';
import Property from './Property';
import Relationship from './Relationship';
import Metadata from './Metadata';

// TODO: Remove this when agent doesn't need to store entire snapshots
const AgentOrAgentId = types.snapshotProcessor(Agent, {
    preProcessor(snapshot) {
        // We used to store only IDs but there was some miscommunication on how we store agents
        if (snapshot?.id || typeof snapshot === 'string') {
            const agentID = snapshot?.id ?? snapshot;

            return { 
                agentID, 
            };
        }

        return snapshot;
    },
});

const Application = types
    .model('Application', {
        otherProperties: types.array(Property),
        attachments: types.array(Attachment),
        agent: types.maybe(AgentOrAgentId), // TODO: Want to avoid storing entire snapshot 
        closingDate: types.maybe(IsoDate),
        firstTimeHomeBuyer: types.maybe(types.boolean),
        appointmentDatetime: types.maybe(IsoDateTimeWithOffset),
        appointmentTimezone: types.maybe(types.string), // utc offset
        appointmentID: types.maybe(types.string),
        notes: types.maybe(types.string),
        relationships: types.array(Relationship),
        metadata: types.optional(Metadata, {}),
    })
    .views(self => ({
        get journey() {
            return getParent(self);
        },
        attachment(searchID) {
            return self.attachments.find(({ id }) => id === searchID);
        },
    }))
    .actions(self => ({
        addAttachment(attachmentSnapshot) {
            const existingAttachment = self.attachment(attachmentSnapshot.id);
            if (existingAttachment) {
                partiallyUpdateModel(existingAttachment, attachmentSnapshot);
            } else {
                self.attachments.push(attachmentSnapshot);
            }

            self.journey.updateLastEditDate();
        },
        removeAttachment(attachmentID) {
            const attachment = self.attachment(attachmentID);
            
            if (attachment) {
                self.attachments.remove(attachment);
                self.journey.updateLastEditDate();
            }
        },
    }));

export default Application;